/**
 * Note Service
 * Register Angular Services for HCP
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Note', ['$resource', function($resource){
    return $resource('/api/v2/note/:id', {id: '@id'}, {
        'update': { method:'PUT' }
    });
}]);
